/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

import { Constants } from 'app/shared/models/constants.model';

@Injectable({ providedIn: 'root' })
export class DateFormatterService {
  constructor() {}

  private static dateToNewFormat(startDate, endDate, format) {
    let monthFormat = 'MMMM';
    if (format === Constants.DATE_FORMATS.SHORT) {
      monthFormat = 'MMM';
    }

    let dateDiff: string;
    if (startDate && endDate) {
      const momentStartDate = dayjs.utc(startDate);
      const momentEndDate = dayjs.utc(endDate);
      const monthsMatch = momentStartDate.isSame(momentEndDate, 'month');
      const daysMatch = momentStartDate.isSame(momentEndDate, 'day');
      const yearsMatch = momentStartDate.isSame(momentEndDate, 'year');

      if (daysMatch) {
        dateDiff = momentStartDate.format(`${monthFormat} D, YYYY`);
      } else {
        dateDiff = momentStartDate.format(`${monthFormat} D`);
        if (!yearsMatch) {
          dateDiff += momentStartDate.format(`, YYYY`);
        }
        dateDiff += ' - ';
        if (!monthsMatch) {
          dateDiff += momentEndDate.format(`${monthFormat} D, YYYY`);
        } else {
          dateDiff += momentEndDate.format(`D, YYYY`);
        }
      }
    }

    return dateDiff;
  }

  static formatDate(startDate, endDate) {
    return this.dateToNewFormat(startDate, endDate, Constants.DATE_FORMATS.NORMAL);
  }

  static formatShortDate(startDate, endDate) {
    return this.dateToNewFormat(startDate, endDate, Constants.DATE_FORMATS.SHORT);
  }
}
